import cx from 'classnames';
import { Ref, forwardRef } from 'react';
import { FilterType, FilterValue } from '@/models';
import { CloseIcon } from '@/components/base/Icons/RocheIconPack';
import styles from './ActiveFilter.module.scss';
import useFormattedGlobalFilterValue from './hooks/useFormattedGlobalFilterValue';
import { useGetActiveFilterAdditionalText } from './hooks/useGetActiveFilterAdditionalText';

interface ActiveFilterProps {
  filterKey: FilterType | string;
  value: FilterValue;
  onDelete?: () => void;
  className?: string;
}

const ActiveFilter = ({ filterKey, value, onDelete, className }: ActiveFilterProps, ref: Ref<HTMLDivElement>) => {
  const formattedValue = useFormattedGlobalFilterValue({ filterKey, value });
  const filterAdditionalText = useGetActiveFilterAdditionalText(filterKey);

  return (
    <div ref={ref} className={cx(styles.activeFilterContainer, className)}>
      <span>
        <div className={styles.labelWrapper}>{formattedValue}</div>
      </span>
      {filterAdditionalText && <span className={styles.additionalText}>{filterAdditionalText}</span>}
      {onDelete && (
        <span className={styles.closeIcon}>
          <CloseIcon width="1.6rem" onClick={onDelete} />
        </span>
      )}
    </div>
  );
};

export default forwardRef(ActiveFilter);
